// extracted by mini-css-extract-plugin
module.exports =  {"highlight":"kd9NZUy","price-wrapper":"tvlf3_I","priceWrapper":"tvlf3_I"};